import { createInternalApiAction } from '@app/packages/internalApi/utils'

export type CookieOptions = {
  path?: string
  domain?: string
  httpOnly?: boolean
  secure?: boolean
  sameSite?: 'lax' | 'strict' | 'none' | 'Lax' | 'Strict' | 'None'
  expires?: string
  maxAge?: number
  overwrite?: boolean
}

export const postCookie = (params: { name: string; value: string; options?: CookieOptions }) =>
  createInternalApiAction('postCookie', dispatch =>
    dispatch<void>({
      endpoint: '/internal/api/v1/cookie',
      method: 'POST',
      body: JSON.stringify(params),
      // Writing a cookie must never trigger the JWT refresh routine — it runs from
      // inside onSessionRefreshed, and depending on auth here would re-enter it.
      skipAuth: true,
    })
  )

export const deleteCookie = (params: { name: string; options?: Pick<CookieOptions, 'path' | 'domain'> }) =>
  createInternalApiAction('deleteCookie', dispatch =>
    dispatch<void>({
      endpoint: '/internal/api/v1/cookie',
      method: 'DELETE',
      body: JSON.stringify(params),
      skipAuth: true,
    })
  )
